// NoMatch.js
export default function NoMatch() {
    return (
      <div>
        <h1>404</h1>
        <p>Page not found. Please check the URL and try again.</p>
      </div>
    );
  }